<div class="inmodal modal-lg">
  <div class="modal-header">
    <h4 class="modal-title text-center full-width" id="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <h4>{{ body }}</h4>
  </div>
  <div class="modal-footer">
    <shared-ui-buttons-button [text]="cancelButtonTitle" [type]="ButtonType.DefaultOutline" (action)="activeModal.dismiss()"></shared-ui-buttons-button>
    <shared-ui-buttons-button *ngIf="canConfirm" [text]="confirmButtonTitle" [type]="ButtonType.Danger" (action)="confirmClose()"></shared-ui-buttons-button>
  </div>
</div>
